export default "__VITE_ASSET__fb1827af__"